import { render } from "./sort-az.svg?vue&type=template&id=65839fbe"
const script = {}
script.render = render

export default script